import { makeStyles } from '@material-ui/core/styles';

import { cardRadius, cardShadow, colors } from '../../tokens';

const useStyles = makeStyles(theme => ({
  withdrawal: {
    borderRadius: cardRadius,
    overflow: 'hidden',
    boxShadow: cardShadow,
  },
  withdrawalHeader: {
    height: 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 3),
    cursor: 'pointer',
  },
  withdrawalLeft: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
  },
  withdrawalText: {
    color: '#070707',
    fontSize: 18,
    fontWeight: 400,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  withdrawalBold: {
    fontWeight: 700,
  },
  bagIcon: {
    marginRight: theme.spacing(2.5),
    fontSize: 24,
    color: '#070707',
  },
  infoIcon: {
    marginLeft: theme.spacing(1),
    fontSize: 16,
    opacity: 0.7,
  },
  customTooltip: {
    background: '#696969',
    color: '#fff',
    fontSize: 12,
    lineHeight: 1.25,
    maxWidth: 320,
    fontWeight: 700,
  },
  rowArrow: {
    color: colors.textSecondary,
    fontSize: 24,
  },
  withdrawalTableHead: {
    display: 'grid',
    gridTemplateColumns: '1.2fr 0.75fr 1.25fr 1.25fr 1.1fr 34px',
    alignItems: 'center',
    minHeight: 58,
    borderBottom: `1px solid ${colors.divider}`,
    padding: theme.spacing(0, 2.5),
    background: colors.paper,
  },
  withdrawalRow: {
    display: 'grid',
    gridTemplateColumns: '1.2fr 0.75fr 1.25fr 1.25fr 1.1fr 34px',
    alignItems: 'center',
    minHeight: 78,
    borderBottom: `1px solid ${colors.divider}`,
    padding: theme.spacing(0, 2.5),
    background: colors.paper,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  withdrawalRowsScroll: {
    maxHeight: 390,
    overflowY: 'auto',
    background: colors.paper,
  },
  tableCell: {
    fontSize: 15,
    color: colors.textPrimary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tableHeadCell: {
    color: colors.textSecondary,
    fontSize: 15,
  },
}));

export default useStyles;
